export default __webpack_public_path__ + "static/media/auth_service_facebook.e13fc20b.svg";